/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { LocationInfo } from "../../shared/models/Location";
import { MapContext } from "../../containers/Map.context";
import { selectLocation } from "../../containers/Map.action";
import "./Panel.scss";

const Panel = (props: React.PropsWithChildren<LocationInfo>) => {
	const { state, dispatch } = useContext(MapContext);
	const [expanded, setExpanded] = React.useState(false);
	const locationId = `location-${props.id}`;

	const locateHandler = () => {
		if (state.mapRef) {
			state.mapRef.setCenter(props.position);
			state.mapRef.setZoom(14);
		}

		const action = selectLocation(props);
		dispatch(action);
	};

	return (
		<div className="col-md-4" id="panel">
			<a
				className="card mb-5 shadow-sm"
				onClick={() => setExpanded(!expanded)}
				data-target={`#${locationId}`}
				data-toggle="collapse"
				aria-expanded="false"
				aria-controls="collapseExample"
			>
				<div className="panel-header">
					<div className="card-title panel-title">
						<div>
							<i className="fas fa-map-marker-alt pr-1" />
							{props.title}
						</div>
					</div>

					<i
						className={`fas ${
							expanded ? " fa-chevron-up " : " fa-chevron-down "
						} pl-1`}
					/>
				</div>
				<div className="collapse location-body" id={locationId}>
					<div className="card card-body panel-content">
						<span
							style={{
								fontSize: "14px",
								fontWeight: "bold",
								paddingBottom: "4px",
							}}
						>
							Weststar Mortgage Corporation
						</span>
						{props.dba.map((location) => {
							return <span>{location + "\r\n"}</span>;
						})}
						{props.address} <br />
						{props.address2} <br />
						{props.city}, {props.state} {props.zip}
						<span style={{ paddingTop: "4px" }}>{props.phone}</span>
						<span style={{ paddingTop: "4px" }}>{props.phone2}</span>
						<span style={{ paddingTop: "4px" }}>{props.email}</span>
						{props.nmls && (
							<span style={{ paddingTop: "4px" }}>NMLS#: {props.nmls}</span>
						)}
						{props.license && (
							<span style={{ paddingTop: "4px" }}>License/Registration:</span>
						)}
						{props.license &&
							props.license.map((value) => {
								return (
									<span key={value} style={{ paddingLeft: "8px" }}>
										{value}
									</span>
								);
							})}
						<button className="btn btn-primary mt-2" onClick={locateHandler}>
							Locate
						</button>
					</div>
				</div>
			</a>
		</div>
	);
};
export default Panel;
